<h1 class="text-center pt-5">Elérhetőségeink:</h1>
<h1 class="font-bold text-center pt-3">Email: info@uvegszerviz.hu</h1>
<h1 class="font-bold text-center pt-3">Telefon: +36 30 952 6593</h1>